import { IS_LOADING, SET_DATA_ID, SET_DATA_ITEM, SET_DATA_LIST, SET_ERROR, SET_SUCCESS, SET_TOTAL } from "@/store/Crud/functions/mutations";
export function SET_SUBCATEGORY_DATA(state, data) {
    state.subCategory = data;
}
export function SET_CURRENT_CLASS_CATEGORY(state, data) {
    state.currentClassCategory = data;
}
export function SET_YOUTUBE_LINK(state, data) {
    state.youtubeLink = data;
}
export default {
    IS_LOADING,
    SET_ERROR,
    SET_SUCCESS,
    SET_DATA_ITEM,
    SET_DATA_ID,
    SET_DATA_LIST,
    SET_TOTAL,
    SET_SUBCATEGORY_DATA,
    SET_CURRENT_CLASS_CATEGORY,
    SET_YOUTUBE_LINK,
};
